const colors = {
  primary50: '#EEFFF6',
  primary100: '#D5FFE8',
  primary300: '#56F09F',
  primary500: '#19C276',
  primary700: '#147D63',
  primary800: '#004737',
  primary900: '#032019',
  secondary50: '#667085',
  neutral50: '#FAFAFA',
  neutral100: '#F5F5F5',
  neutral200: '#E5E5E5',
  neutral300: '#D6D6D6',
  neutral400: '#A3A3A3',
  neutral500: '#737373',
  neutral600: '#525252',
  neutral700: '#424242',
  neutral900: '#141414',
  cream50: '#FFFBEC',
  cream300: '#DFDCCD',
  blue50: '#F0F9FF',
  blue100: '#E0F2FE',
  blue300: '#7CD4FD',
  blue500: '#0BA5EC',
  blue600: '#0086C9',
  blue700: '#026AA2',
  violet50: '#F5F3FF',
  violet100: '#ECE9FE',
  violet300: '#C3B5FD',
  violet500: '#875BF7',
  violet600: '#7839EE',
  violet700: '#6927DA',
  red50: '#FEF3F2',
  red100: '#FEE4E2',
  red300: '#FDA29B',
  red500: '#F04438',
  red600: '#D92D20',
  red700: '#B42318',
  orange50: '#FFFAEB',
  orange100: '#FEF0C7',
  orange300: '#FEC84B',
  orange500: '#F78F08',
  orange600: '#DC6803',
  orange700: '#B54708',
  fuchsia50: '#FDF4FF',
  fuchsia100: '#FBE8FF',
  fuchsia500: '#D444F1',
  fuchsia600: '#BA24D5',
  fuchsia700: '#9F1AB1 ',
  white: '#FFFFFF',
  black: '#000000',
}

export default colors
